export const getVariantAttributesGetter = state => {
  let attributes = [
    {
      attribute: '',
      value: []
    },
    {
      attribute: '',
      value: []
    },
    {
      attribute: '',
      value: []
    }
  ]
  state.attributes.forEach((element, index, array) => {
    attributes[index] = element
  })
  return attributes
}

export const getProductVariantsList = state => {
  return state.result.lists
}

export const getProductVariantsSearch = state => {
  return state.search
}



// WEBPACK FOOTER //
// ./src/store/modules/variants/getters.js